import * as z from "zod";
import { gql } from "graphql-request";

import { NewsEntrySchema } from "./newsEntry";
import {
  NewsEntryArticleSchema,
  NewsEntryArticleFragment,
} from "./newsEntryArticle";
import {
  SmallNewsEntryArticleSchema,
  SmallNewsEntryArticleFragment,
} from "./smallNewsEntryArticle";

import { SysFragment } from "../sys";
import { ImageFragment } from "../image";

export const BlogNewsEntrySchema = NewsEntrySchema.extend({
  localized: z
    .union([
      z.null(),
      z.unknown(),
      NewsEntryArticleSchema,
      SmallNewsEntryArticleSchema,
    ])
    .nullable(),
});

export const BlogNewsEntry = BlogNewsEntrySchema;
export type BlogNewsEntry = z.infer<typeof BlogNewsEntrySchema>;

export const BlogNewsEntryFragment = gql`
  fragment BlogNewsEntryFragment on NewsEntry {
    sys {
      ...SysFragment
    }

    categoryEn: category(locale: "en") {
      categoryId
      name
      color
      secondaryColor
    }

    category {
      categoryId
      name
      color
      secondaryColor
    }

    newUntil
    sortDate
    localized {
      __typename
      ... on NewsEntryArticle {
        ...NewsEntryArticleFragment
      }

      ... on SmallNewsEntryArticle {
        ...SmallNewsEntryArticleFragment
      }
    }
  }

  ${SysFragment}
  ${ImageFragment}
  ${NewsEntryArticleFragment}
  ${SmallNewsEntryArticleFragment}
`;
